window.addEventListener('load', function () {
  const selectors = {
    newArrivalsSlider: '.home__new-arrivals__content__slider',
    heroVideo: '.home__hero__video',
    categoriesItem: '.home__new-arrivals__content__categories__item',
    categoriesItemActive:
      '.home__new-arrivals__content__categories__item--active',
    newArrivalsSlider: '.home__new-arrivals__content__slider',
    newArrivalsSliderActive: '.home__new-arrivals__content__slider--active',
    kitsAndBundlesSlider: '.home__kits-bundles__content__slider',
    shopVideoSlider: '.home__shop-video__content__slider',
    shopVideoSliderSlide: '.home__shop-video__content__slider__wrapper__slide',
    shopVideoSliderSlideActive:
      '.home__shop-video__content__slider__wrapper__slide--active',
    pressQuote: '.home__press__content__quotes__item',
    pressQuoteActive: '.home__press__content__quotes__item--active',
    pressImage: '.home__press__content__images__item',
    pressImageActive: '.home__press__content__images__item--active',
    socialFeedTiktokItem: '.home__social-feed__content__item__tiktok'
  };

  function containsClass(domEl, classStr) {
    if (domEl.classList.contains(classStr)) {
      return true;
    }
    return false;
  }

  let lastSize = 0;
  // Hero Section
  const HeroSection = () => {
    let resizeTimer;

    function adjustHeroVideo() {
      const heroVideo = document.querySelector(selectors.heroVideo);

      if (!heroVideo) {
        return;
      }

      const mobileVideo = heroVideo.dataset.mobileVideo;
      const desktopVideo = heroVideo.dataset.desktopVideo;
      const mobilePoster = heroVideo.dataset.mobilePoster;
      const desktopPoster = heroVideo.dataset.desktopPoster;

      if (lastSize != window.innerWidth) {
        if (window.innerWidth < 768) {
          heroVideo.src = mobileVideo;
          heroVideo.setAttribute('poster', mobilePoster);
        } else {
          heroVideo.src = desktopVideo;
          heroVideo.setAttribute('poster', desktopPoster);
        }
        lastSize = window.innerWidth;
      }
    }

    if (document.querySelector(selectors.heroVideo)) {
      adjustHeroVideo();
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          adjustHeroVideo();
        }, 250);
      });
    }
  };
  // End Hero Section

  // New Arrivals Section
  const NewArrivalsSection = () => {
    function newArrivalsSlider() {
      const sliderOptions = {
        slidesPerView: 2.1,
        spaceBetween: 4,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        loop: false,
        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 3,
            centeredSlides: false,
            threshold: 32,
            navigation: {
              nextEl: '.home__new-arrivals__content__slider__next',
              prevEl: '.home__new-arrivals__content__slider__prev'
            }
          },
          1024: {
            spaceBetween: 16,
            slidesPerView: 4,
            centeredSlides: false,
            threshold: 32,
            navigation: {
              nextEl: '.home__new-arrivals__content__slider__next',
              prevEl: '.home__new-arrivals__content__slider__prev'
            }
          }
        }
      };

      new Swiper(selectors.newArrivalsSlider + '--active', sliderOptions);
    }

    function handleCategoriesItems() {
      const categoriesItems = document.querySelectorAll(
        selectors.categoriesItem
      );

      if (!categoriesItems.length) {
        return;
      }

      function switchCategory(e) {
        e.preventDefault();

        function getActiveCategory() {
          const activeCategory = document.querySelector(
            selectors.categoriesItemActive
          );
          const activeCategoryCollection =
            activeCategory.dataset.sliderCollection;
          return `${selectors.categoriesItemActive}[data-slider-collection="${activeCategoryCollection}"]`;
        }

        if (containsClass(this, selectors.categoriesItemActive.slice(1))) {
          return;
        }

        const sliderCollection = this.dataset.sliderCollection;
        const activeCategory = getActiveCategory();

        // Switch Category
        document.querySelector(activeCategory).style.textDecoration = 'none';
        document
          .querySelector(activeCategory)
          .classList.remove(selectors.categoriesItemActive.slice(1));

        this.classList.add(selectors.categoriesItemActive.slice(1));
        this.style.textDecoration = 'underline';

        // Switch Slider
        switchSlider(sliderCollection);
      }

      function switchSlider(category) {
        function getActiveSlider() {
          const slider = document.querySelector(
            selectors.newArrivalsSliderActive
          );
          const activeSliderCollection = slider.dataset.sliderCollection;
          return `${selectors.newArrivalsSliderActive}[data-slider-collection="${activeSliderCollection}"]`;
        }
        const activeSlider = getActiveSlider();

        document.querySelector(activeSlider).style.display = 'none';
        document
          .querySelector(activeSlider)
          .classList.remove(selectors.newArrivalsSliderActive.slice(1));
        document
          .querySelector(
            `${selectors.newArrivalsSlider}[data-slider-collection="${category}"]`
          )
          .classList.add(selectors.newArrivalsSliderActive.slice(1));
        document
          .querySelector(
            `${selectors.newArrivalsSlider}[data-slider-collection="${category}"]`
          )
          .setAttribute('style', 'display: block !important');
        newArrivalsSlider();
      }

      categoriesItems.forEach(function (item) {
        item.addEventListener('click', switchCategory);
      });
    }

    newArrivalsSlider();
    handleCategoriesItems();
  };
  // End New Arrivals Section

  // Kits and Bundles Section
  const KitsAndBundlesSection = () => {
    function slider() {
      const sliderOptions = {
        slidesPerView: 2.1,
        spaceBetween: 4,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 3,
            centeredSlides: false,
            threshold: 32,
            navigation: {
              nextEl: '.home__kits-bundles__content__slider__next',
              prevEl: '.home__kits-bundles__content__slider__prev'
            }
          },
          1024: {
            spaceBetween: 16,
            slidesPerView: 4,
            centeredSlides: false,
            threshold: 32,
            navigation: {
              nextEl: '.home__kits-bundles__content__slider__next',
              prevEl: '.home__kits-bundles__content__slider__prev'
            }
          }
        }
      };

      new Swiper(selectors.kitsAndBundlesSlider, sliderOptions);
    }

    slider();
  };
  // End Kits and Bundles Section

  // Press Section
  const PressSection = () => {
    const pressQuotes = document.querySelectorAll(selectors.pressQuote);
    const pressImages = document.querySelectorAll(selectors.pressImage);
    let pressInterval;
    let count = 0;

    function changeActiveQuote(index) {
      for (let i = 0; i < pressQuotes.length; i++) {
        if (parseInt(pressQuotes[i].dataset.index) === parseInt(index)) {
          pressQuotes[i].classList.add(selectors.pressQuoteActive.slice(1));
        } else {
          pressQuotes[i].classList.remove(selectors.pressQuoteActive.slice(1));
        }
      }
    }

    function onClickChangeActiveImage() {
      count = parseInt(this.dataset.index) - 1;
      clearInterval(pressInterval);

      setTimeout(() => {
        pressInterval = setInterval(changeActiveImage, 3500);
      }, 3500);

      if (containsClass(this, selectors.pressImageActive.slice(1))) {
        return;
      }

      for (let i = 0; i < pressImages.length; i++) {
        if (
          containsClass(pressImages[i], selectors.pressImageActive.slice(1))
        ) {
          pressImages[i].classList.remove(selectors.pressImageActive.slice(1));
        }
      }

      this.classList.add(selectors.pressImageActive.slice(1));
      changeActiveQuote(this.dataset.index);
    }

    function changeActiveImage() {
      for (let i = 0; i < pressImages.length; i++) {
        if (
          containsClass(pressImages[i], selectors.pressImageActive.slice(1))
        ) {
          pressImages[i].classList.remove(selectors.pressImageActive.slice(1));
        }
      }

      if (count === pressQuotes.length - 1) {
        pressImages[0].classList.add(selectors.pressImageActive.slice(1));
        changeActiveQuote(1);
        count = 0;
      } else {
        pressImages[count + 1].classList.add(
          selectors.pressImageActive.slice(1)
        );
        changeActiveQuote(count + 2);
        count += 1;
      }
    }

    setTimeout(() => {
      if (!pressInterval) {
        pressInterval = setInterval(changeActiveImage, 3500);
      }
    }, 3500);

    for (let i = 0; i < pressImages.length; i++) {
      pressImages[i].addEventListener('click', onClickChangeActiveImage);
    }
  };
  // End Press Section

  const UniqueQuickInputs = () => {
    const quickAddInputs = document.querySelectorAll(
      '[data-quick-add-variant-input]'
    );
    const quickAddLabels = document.querySelectorAll(
      '[data-quick-add-variant-label]'
    );

    if (!quickAddInputs.length || !quickAddLabels.length) {
      return;
    }

    for (let i = 0; i < quickAddInputs.length; i++) {
      let randomNumber = Math.floor(Date.now() + Math.random() * 1000);
      quickAddInputs[i].id = quickAddInputs[i].id + '-' + randomNumber;
      quickAddLabels[i].htmlFor =
        quickAddLabels[i].htmlFor + '-' + randomNumber;
    }
  };

  // HeroSection()
  NewArrivalsSection();
  KitsAndBundlesSection();
  UniqueQuickInputs();
  PressSection();
});
